// extracted by mini-css-extract-plugin
export default {"-large":"JxxYN580XDcHIhEPy1m4","creditsPillContainer":"N_Er0UVQvFqFwtEoziGo","premium":"BWG75JiwnrePnBQVFkiW"};